import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { NavigationError, provideRouter, withComponentInputBinding, withNavigationErrorHandler } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { routes } from './app.routes';
import { authInterceptor } from '@core/interceptors/auth.interceptor';
import { encryptionInterceptor } from '@shared/crypto/encryption.interceptor';

/** Tras un deploy, los chunks del build anterior ya no existen: se recarga una vez para traer el index nuevo. */
const reloadOnStaleChunk = (e: NavigationError): void => {
  if (!/dynamically imported module|Importing a module script failed|ChunkLoadError/i.test(String((e.error as any)?.message ?? e.error))) return;
  try {
    const last = Number(sessionStorage.getItem('chunk-reload') || 0);
    if (Date.now() - last < 10_000) return; // si el servidor sigue sirviendo mal, no entra en bucle
    sessionStorage.setItem('chunk-reload', String(Date.now()));
  } catch { /* sin sessionStorage: se recarga igual una vez por error */ }
  window.location.assign(e.url);
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding(), withNavigationErrorHandler(reloadOnStaleChunk)),
    provideClientHydration(withEventReplay()),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor, encryptionInterceptor])),
  ],
};
